import { Button } from '@playbooks/ui/components/button'
import { Unlock, Lock } from 'lucide-react'

export default function LockUnlockButton({
  isLocked,
  onClick,
}: {
  isLocked: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}) {
  return (
    <Button variant="ghost" size="icon" onClick={onClick}>
      {isLocked ? <Lock className="text-red-400" size={16} /> : <Unlock size={16} />}
    </Button>
  )
}
